import { enableProdMode, MissingTranslationStrategy, LOCALE_ID, TRANSLATIONS, TRANSLATIONS_FORMAT } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { constants } from './app/app-constants';

if (environment.production) {
  enableProdMode();
}

let localeSetting = '';
const listLocaleSuported = ['pt', 'es', 'en'];

const languages = window.navigator.languages;

const verifyLocal = localStorage.getItem(constants.locale);

if (verifyLocal === '' || verifyLocal === null) {

  languages.forEach(function (local) {
    for (let i = 0; i < listLocaleSuported.length; i++) {
        if (localeSetting === '' && local === listLocaleSuported[i]) {
          localeSetting = local;
          break;
        }
    }
  });

  localStorage.setItem(constants.locale, localeSetting);
}

if (localeSetting === '') {
  localeSetting = 'pt';
} else {
  localStorage.setItem(constants.locale, localeSetting);
}

const locale = localStorage.getItem(constants.locale);
declare const require;
const translations = require(`raw-loader!./locale/messages.${(locale === '' ? localeSetting : locale)}.xlf`);

platformBrowserDynamic([{ provide: LOCALE_ID, useValue: locale }])
  .bootstrapModule(AppModule, {
    missingTranslation: MissingTranslationStrategy.Error,
    providers: [
      { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
      { provide: TRANSLATIONS, useValue: translations, deps: LOCALE_ID },
    ]
  })
  .catch(err => console.error(err)
  );

